/* SLIDE 31 */

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedSpots, fetchAllParkingSpots, fetchAllParkingSpotTypes } from "features/parking/presentation/store/parkingSlice";
import SearchBar from "shared/components/SearchBar";

const PakingCalendarDetailPage = () => {

  const dispatch = useDispatch();

  useEffect(() => {

    dispatch(fetchAllParkingSpots());
    dispatch(fetchAllParkingSpotTypes());

  }, [dispatch]);
  const today = new Date();
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());

  const months = Array.from({ length: 12 }, (_, i) => i + 1);

  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const getDaysInPreviousMonth = (year, month) => {
    const prevMonth = month === 0 ? 11 : month - 1;
    const prevYear = month === 0 ? year - 1 : year;
    return getDaysInMonth(prevYear, prevMonth);
  };

  const getStartDay = (year, month) => {
    return new Date(year, month, 1).getDay();
  };

  const daysInMonth = getDaysInMonth(currentYear, currentMonth);
  const startDay = getStartDay(currentYear, currentMonth);
  const prevMonthDays = getDaysInPreviousMonth(currentYear, currentMonth);
  const days = [];

  for (let i = startDay - 1; i >= 0; i--) {
    days.push({
      day: prevMonthDays - i,
      currentMonth: false,
    });
  }

  for (let i = 1; i <= daysInMonth; i++) {
    days.push({
      day: i,
      currentMonth: true,
    });
  }

  let nextMonthDay = 1;
  while (days.length < 42) {
    days.push({
      day: nextMonthDay++,
      currentMonth: false,
    });
  }

  const [selectedOption, setSelectedOption] = useState("사용자정보(01-002)");

  const options = [
    "사용자정보(01-002)",
    "사용자정보(01-001)",
    "사용자정보(01-003)",
  ];
  const handleChange = (e) => {
    setSelectedOption(e.target.value);
  };
  return (
    <div className={`parking-status-container`}>

      <SearchBar />
      <div className="htContent">
        <div className="table-header">
          <select
            className="table-select"
            value={selectedOption}
            onChange={handleChange}
          >
            {options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <div className="mn-calendar-header">
          <select
            value={currentYear}
            onChange={(e) => setCurrentYear(Number(e.target.value))}
          >
            {Array.from({ length: 5 }, (_, i) => today.getFullYear() - 2 + i).map((year) => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
          <select
            value={currentMonth + 1}
            onChange={(e) => setCurrentMonth(Number(e.target.value) - 1)}
          >
            {months.map((month) => (
              <option key={month} value={month}>{month}</option>
            ))}
          </select>
        </div>

        <div className="schedule-container">
          <div className="date-detail-header">
            <span className="day-text">월 23</span>
          </div>

          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className="schedule-item">
              <div className="name">홍길동</div>
              <div className="time">08:00 ~ 17:00</div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default PakingCalendarDetailPage;
